function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
export const cellHead = [
  {
    headerName: 'Date',
    field: 'processDt',
    editable: false,
    minWidth: 100,
    maxWidth: 250,
    comparator: dateComparator,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Submitted By',
    field: 'processUserId',
    editable: false,
    minWidth: 100,
    maxWidth: 250,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      // closeOnApply: true,
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Name',
    field: 'processName',
    editable: false,
    minWidth: 200,
    columnSpan: 3,
    resizable: false,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      // closeOnApply: true,
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
export const cellHead1 = [
  {
    headerName: 'Information',
    field: 'processText',
    editable: false,
    minWidth: 730,
    sortable: true,
    resizable: true,
    columnSpan: 5,
    autoHeight: true,
    wrapText: true,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Type',
    field: 'processTypeCd',
    editable: false,
    sortable: true,

    sortingOrder: ['desc', 'asc'],
    showDropDownVal: true,
    dropDownValueCol: 'invoiceHandlingCdValWithLabel',
    cellStyle: { borderRightColor: '#D6D2D0' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
